import { render } from "./_Index.vue?vue&type=template&id=b7a2d298&scoped=true"
import script from "./_Index.vue?vue&type=script&lang=ts"
export * from "./_Index.vue?vue&type=script&lang=ts"

import "./_Index.vue?vue&type=style&index=0&id=b7a2d298&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b7a2d298"

export default script